import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import { Loading } from '@rd-web-markets/shared/dist/util';
import NotesAndAssumptionsList from './NotesAndAssumptionsList';
import NotesAndAssumptionForm from './NotesAndAssumptionForm';
import notesAndAssumptionsService from './notesAndAssumptions.service';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import notesAndAssumptionReviewsService from './notesAndAssumptionReviews.service';
import changeSetNotesAndAssumptionsMailerService from './changeSetNotesAndAssumptionsMailer.service';
const NotesAndAssumptionsPage = _ref => {
  var _notes$find;
  let {
    accountType,
    claim
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const {
    notes,
    categories,
    createNote,
    updateNote,
    deleteNote,
    fetchNotes
  } = notesAndAssumptionsService.useCrud(setLoading, claim === null || claim === void 0 ? void 0 : claim.id);
  const [updateReview] = notesAndAssumptionReviewsService.useUpdate(setLoading, claim === null || claim === void 0 ? void 0 : claim.id, fetchNotes);
  const activeChangeSetId = !!(notes !== null && notes !== void 0 && notes.length) ? (_notes$find = notes.find(n => n.has_active_cost_review)) === null || _notes$find === void 0 || (_notes$find = _notes$find.current_review) === null || _notes$find === void 0 ? void 0 : _notes$find.change_set_id : null;
  const [sendReviewerEmail] = changeSetNotesAndAssumptionsMailerService.useSendReviewerEmail(setEmailLoading, activeChangeSetId);
  const [sendResponseEmail] = changeSetNotesAndAssumptionsMailerService.useSendResponseEmail(setEmailLoading, activeChangeSetId);
  const handleSendReviewerEmail = async () => {
    await sendReviewerEmail();
    await fetchNotes();
  };
  const handleSendResponseEmail = async () => {
    await sendResponseEmail();
    await fetchNotes();
  };
  const handleCreateNote = async formData => {
    await createNote(formData);
    setShowForm(false);
  };
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  const hasActiveReview = notes === null || notes === void 0 ? void 0 : notes.some(note => note.has_active_cost_review);
  const userCanEdit = hasPermissions() && !(claim !== null && claim !== void 0 && claim.financials_locked) && !(claim !== null && claim !== void 0 && claim.is_locked) && !hasActiveReview;
  if (!claim || !notes) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("span", null, t('notes_and_assumptions')), hasPermissions() && !(claim !== null && claim !== void 0 && claim.financials_locked) && !(claim !== null && claim !== void 0 && claim.is_locked) && /*#__PURE__*/React.createElement(AddButton, {
    size: "sm",
    variant: "info",
    disabled: loading,
    onClick: () => setShowForm(prev => !prev),
    text: showForm ? t('hide_form') : t('add_note')
  }))), /*#__PURE__*/React.createElement(Card.Body, null, hasActiveReview && /*#__PURE__*/React.createElement(Alert, {
    variant: "warning",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("strong", null, "Review in Progress:"), " Editing, and deleting notes is disabled while a cost review is active."), showForm && /*#__PURE__*/React.createElement(NotesAndAssumptionForm, {
    onSubmit: handleCreateNote,
    loading: loading,
    categories: categories
  }), notes.length === 0 && !showForm ? /*#__PURE__*/React.createElement("div", {
    className: "text-center py-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-3"
  }, t('no_notes_yet')), userCanEdit && /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowForm(true)
  }, t('add_first_note'))) : /*#__PURE__*/React.createElement(NotesAndAssumptionsList, {
    notes: notes,
    categories: categories,
    onUpdate: updateNote,
    onDelete: deleteNote,
    userCanEdit: userCanEdit,
    onReviewUpdate: updateReview,
    loading: loading,
    claimId: claim.id,
    fetchNotes: fetchNotes,
    onSendReviewerEmail: handleSendReviewerEmail,
    onSendResponseEmail: handleSendResponseEmail,
    emailLoading: emailLoading,
    user: user
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "outline-primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/general")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/staffing_costs")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right")))));
};
export default NotesAndAssumptionsPage;